<script setup lang="ts">
import { computed } from 'vue';
import { ArrowClockwiseIcon, CheckmarkCircleIcon, DismissCircleIcon } from '@blpde/nx-icons';

export type State = 'loading' | 'error' | 'success' | 'idle';
const { state, fadeOut, fadeOutDuration } = defineProps<{
  state: State;
  fadeOut: boolean;
  fadeOutDuration: string;
}>();
defineOptions({ inheritAttrs: false });

const iconComponent = computed(() => {
  switch (state) {
    case 'loading':
      return ArrowClockwiseIcon;
    case 'success':
      return CheckmarkCircleIcon;
    case 'error':
      return DismissCircleIcon;
    default:
      return null;
  }
});

const iconFontSize = computed(() => (state === 'loading' ? '1.25em' : '1em'));
</script>

<template>
  <component
    :is="iconComponent"
    v-if="iconComponent"
    v-bind="$attrs"
    :class="['icon', state, { fade: fadeOut }]"
    :style="{ '--duration': fadeOutDuration, fontSize: iconFontSize }"
    filled
  />
</template>

<style scoped>
.icon {
  transition: opacity var(--duration) ease-out;

  &.loading:not(#non-existent-id-to-boost-specificity),
  &.loading:not(#non-existent-id-to-boost-specificity) :deep(*) {
    color: var(--nxt-brand-bg);
  }
  &.success:not(#non-existent-id-to-boost-specificity),
  &.success:not(#non-existent-id-to-boost-specificity) :deep(*) {
    color: var(--nxt-success-bg);
  }
  &.error:not(#non-existent-id-to-boost-specificity),
  &.error:not(#non-existent-id-to-boost-specificity) :deep(*) {
    color: var(--nxt-danger-bg);
  }

  &.fade {
    opacity: 0;
  }
}
</style>
